export default __webpack_public_path__ + "a01c7f4510da74c4c76a33848098ee50.svg";